export default __webpack_public_path__ + "static/media/mail-open.69f66133.svg";